import type { GitErrorStatusCode } from './errors/errors.enum';
import type { WorkerAction } from './wasm-git.worker.model';

export interface IGitError {
  gitErrorCode: GitErrorStatusCode;
  message: string;
}

export abstract class GitError extends Error implements IGitError {
  abstract readonly gitErrorCode: GitErrorStatusCode;

  type!: WorkerAction['type'];
  params!: unknown;
  path?: string;
}

export class LibGit2Error extends Error {
  constructor(message: string, rawBytes?: Uint8Array) {
    super(message);
    this.rawBytes = rawBytes;
  }
  rawBytes?: Uint8Array;
}
